var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73.082,
    height: 54.388,
    viewBox: "0 0 73.082 54.388",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 73.082,
    height: 54.388,
    fill: "#2e728c"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 10.048,
    height: 38.848,
    fill: "#2e728c"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M109.886,46.593a51.162,51.162,0,0,1,1.986,13.436c0,11.333-5.141,17.233-14.838,17.233-7.595,0-11.158-3.447-11.158-10.632V46.593H95.69V65.462c0,2.8.292,4.264,2.453,4.264,3.33,0,4.148-4.615,4.148-9.405a61.778,61.778,0,0,0-1.986-13.728Z",
    transform: "translate(-69.402 -37.655)",
    fill: "#2e728c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M261.878,46.593V64.644c0,2.453-1.4,3.914-3.33,3.914-2.8,0-2.979-1.986-2.979-5.141V46.593h-9.814V64.761c0,4.849,2.337,8.354,7.3,9.288-3.68,2.687-5.783,5.959-5.783,9.931,0,4.965,3.5,8.062,10.165,8.062,8.587,0,13.2-4.615,14.079-13.962.175-1.753.175-6.543.175-8.178V46.593Zm1.137,35.422c-.843,3.145-3.376,3.41-6.061,3.188a6.069,6.069,0,0,0,.013,1.972.885.885,0,0,1-.458.007,12.058,12.058,0,0,1,4.122-10.025c-3.14,1.3-4.6,6.453-4.313,7.76-.961-1.363-1.893-2.4-1.723-4.276.337-3.722,5.611-6.583,10.855-4.993-2.477,1.474-1.744,3.792-2.434,6.368",
    transform: "translate(-198.61 -37.655)",
    fill: "#2e728c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardLogo);
export default __webpack_public_path__ + "static/media/dashboard-logo.9d56d844b3d456dc0a13dbf7c33d02ec.svg";
export { ForwardRef as ReactComponent };